var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 15.125H18.75V13.25C18.75 8.84297 15.4887 5.20742 11.25 4.59922V3.875H13.125C13.4703 3.875 13.75 3.59531 13.75 3.25V2.625C13.75 2.27969 13.4703 2 13.125 2H6.875C6.52969 2 6.25 2.27969 6.25 2.625V3.25C6.25 3.59531 6.52969 3.875 6.875 3.875H8.75V4.59922C4.51133 5.20742 1.25 8.84297 1.25 13.25V15.125H0.625C0.279687 15.125 0 15.4047 0 15.75V16.375C0 16.7203 0.279687 17 0.625 17H19.375C19.7203 17 20 16.7203 20 16.375V15.75C20 15.4047 19.7203 15.125 19.375 15.125ZM16.875 15.125H3.125V13.25C3.125 9.45898 6.20898 6.375 10 6.375C13.791 6.375 16.875 9.45898 16.875 13.25V15.125Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.25434ae678c3bddc28272e82f0e21525.svg";
export { ForwardRef as ReactComponent };